import React, { lazy } from "react";
import { Route } from "react-router-dom";

const RouteWrapper = lazy(() => import("./routeWrapper"));

const KYC = lazy(() => import("../pages/kyc"));
const MinimumKyc = lazy(() => import("../pages/kyc/minKYC"));
const DodumentKyc = lazy(() => import("../pages/kyc/documentKYC"));
const EmployeeProfile = lazy(() => import("../pages/employeeprofile"));
const DelegationAdmin = lazy(() => import("../pages/delegationAdmin"));
const EmpReports = lazy(() => import("../components/infoPage/reports"));
const KycUpload = lazy(() => import("../components/settings/delegation"));
const EmpExpenses = lazy(() => import("../components/infoPage/expenses"));
const RoleApprover = lazy(() => import("../components/settings/roleApprover"));
const IndvWalletList = lazy(() => import("../components/user/walletList/index"));
const EmpLoadRequests = lazy(() => import("../components/infoPage/loadRequests"));
const WalletTabs = lazy(() => import("../components/infoPage/userWallet/walletTabs"));
const UserWallet = lazy(() => import("../components/infoPage/userWallet/userWallet"));
const EmpTravelRequests = lazy(() => import("../components/infoPage/travelRequests"));
const UserPassbook = lazy(() => import("../components/infoPage/userWallet/userPassbook"));
const UserSettlement = lazy(() => import("../components/infoPage/userWallet/userSettlement"));
const UserBankTransfer = lazy(() => import("../components/infoPage/userWallet/userBankTransfer"));
const UserSettlementBeta = lazy(() =>
    import("../components/infoPage/userWallet/userSettlementBeta")
);
const UserUpdateLogs = lazy(() => import("../components/infoPage/userUpdateLogs"))

const userWallets = [
    <Route exact path="/users/:id/wallets/userWallet" component={UserWallet} />,
    <Route exact path="/users/:id/wallets/userPassbook" component={UserPassbook} />,
    <Route exact path="/users/:id/wallets/userBankTransfer" component={UserBankTransfer} />,
    <Route exact path="/users/:id/wallets/userSettlement" component={UserSettlement} />,
    <Route exact path="/users/:id/wallets/userSettlementBeta" component={UserSettlementBeta} />
];

const UserRoutes = [
    <Route exact path="/users/:id/profile" component={EmployeeProfile} />,

    <Route exact path="/users/:id/rolenapprovers" component={RoleApprover} />,

    <RouteWrapper
        exact
        path={["/users/:id/wallets", "/users/:id/wallets/*"]}
        layout={WalletTabs}
        routes={userWallets}
    />,

    <Route exact path="/users/:id/expenses" component={EmpExpenses} />,

    <Route exact path="/users/:id/reports" component={EmpReports} />,

    <Route exact path="/users/:id/travelrequests" component={EmpTravelRequests} />,

    <Route exact path="/users/:id/loadrequests" component={EmpLoadRequests} />,

    <Route exact path="/users/:id/kycupload" component={KycUpload} />,

    <Route exact path="/users/:id/walletslist" component={IndvWalletList} />,

    <Route exact path="/users/:id/delegation" component={DelegationAdmin} />,

    <Route exact path="/users/:id/userupdatelogs" component={UserUpdateLogs} />,

    /// New KYC Conponent
    <Route exact path="/users/:id/kycDetails" component={KYC} />,

    <Route exact path="/users/:id/minKyc" component={MinimumKyc} />,

    <Route exact path="/users/:id/documentKyc" component={DodumentKyc} />
];

export default UserRoutes;
